import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";   
import SessionChat from "./SessionChat";  

export default function SessionDetails(){
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    axios.get(`${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}`)
      .then(res => setSession(res.data))
      .catch(err => console.error(err));
  }, [sessionId]);

  if (!session) return <div className="container"><p>Loading session details...</p></div>;

  const renderSummary = () => {
    if (!session.summary) return <p className="small">No summary yet.</p>;
    return <ReactMarkdown>{session.summary}</ReactMarkdown>;   // ✅ render markdown
  };

  return (
    <div className="container">
      <h2>Session Details</h2>

      <div className="grid cols-2" style={{marginBottom:12}}>
        <div className="card">
          <h3 style={{marginTop:0}}>Candidate</h3>
          <div className="small">Name</div>
          <div style={{fontWeight:700}}>{session.interviewee_name}</div>
          <div className="small" style={{marginTop:8}}>Email</div>
          <div>{session.interviewee_email}</div>
          <div className="small" style={{marginTop:8}}>Contact</div>
          <div>{session.contact}</div>
        </div>

        <div className="card">
          <h3 style={{marginTop:0}}>Result</h3>
          <div className="small">Score</div>
          <div style={{fontWeight:700,fontSize:22}}>
            {session.score !== null ? session.score : "N/A"}
          </div>
          <div style={{marginTop:12}} className="small">Status</div>

          <div style={{marginTop:10, display:"flex", justifyContent:"space-between", alignItems:"center"}}>
            {session.completed ? (
              <span className="badge success">Completed</span>
            ) : (
              <span className="badge inprogress">In Progress</span>
            )}
            <button
              className="btn secondary"
              disabled={!session.completed}
              onClick={async () => {
                try {
                  const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/sessions/${sessionId}/summary`
                  );
                  setSession(prev => ({
                    ...prev,
                    summary: res.data.summary,
                    score: res.data.score ?? prev.score,
                  }));
                } catch (err) {
                  alert("Failed to regenerate summary");
                }
              }}
            >
              Regenerate Summary
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        {renderSummary()}
      </div>

      <div className="card">
        <h3 style={{marginTop:0}}>Transcript</h3>
        <div className="chat-window">
          {session.transcript.map((msg, idx) => {
            const label = msg.role === "user" ? session.interviewee_name : localStorage.getItem("name");
            return (
              <div key={idx} className={`chat-row ${msg.role === "user" ? "user" : "assistant"}`}>
                <div className={`bubble ${msg.role === "user" ? "user" : "assistant"}`}>
                  <div style={{fontSize:13, color:"var(--muted)", marginBottom:6}}>{label}</div>
                  <div>{msg.content}</div>
                </div>
              </div>
            );
          })}
        </div>

      </div>

      <SessionChat sessionId={sessionId} />

    </div>
  );
}
